import styled from 'styled-components';

export const VcDisplay = styled.pre`
	margin-top: 20px;
	padding: 10px;
	color: black;
	border-radius: 3px;
	background-color: white;
`;
